import React from 'react';
import { DocumentStatus } from '../../types';
import { CheckIcon, DocumentIcon, RoundCloseIcon } from '../../icons';
export const STATUS_ICONS_MAP = new Map([
    [DocumentStatus.REQUIRED, null],
    [DocumentStatus.SUBMITTED, React.createElement(DocumentIcon, { key: "documentIcon" })],
    [DocumentStatus.VERIFIED, React.createElement(CheckIcon, { key: "checkIcon", width: 24, height: 24, fill: "#4EB280" })],
    [DocumentStatus.REJECTED, React.createElement(RoundCloseIcon, { key: "rejectedIcon", fill: "#F83D49" })],
]);
//# sourceMappingURL=constants.js.map